import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { dateFormat, Plan } from '../../core';
import { AnatomicalSideLabelPipe, BoneTypeLabelPipe, ConvertDatePipe, PlanTypeLabelPipe, ReplaceLongLegPipe } from '../../shared';
import { VwBaseComponent } from '../shared';


/**
 * Plan data of view plan page.
 */
@Component({
	selector: 'vw-plan',
	templateUrl: './vw-plan.component.html',
	imports: [
		ConvertDatePipe,
		PlanTypeLabelPipe,
		BoneTypeLabelPipe,
		ReplaceLongLegPipe,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class VwPlanComponent extends VwBaseComponent {

	plan = input.required<Plan>();

	readonly dateFormat = dateFormat();

}
